import React from "react";
import "./MicroBladingCompare.css";
import MicroBladingCompareHead from "./MicroBladingCompareHead";
import MicroBladingCompareMain from "./MicroBladingCompareMain";
const MicroBladingCompare = () => {
  return (
    <div className="microBladingCompare">
      <MicroBladingCompareHead />
      <MicroBladingCompareMain />
    </div>
  );
};

export default MicroBladingCompare;
